/**
 * Nomi accessibili dei caroselli Splide (acf/carousel e carousel-query).
 *
 * Ogni pulsante icona deve avere un nome univoco che ne descriva la funzione:
 * con più caroselli nella stessa pagina "Slide successiva" si ripete, quindi il
 * nome del carosello entra nel nome delle frecce ("Slide successiva – News").
 * Se due caroselli hanno lo stesso nome, dal secondo in poi si aggiunge un
 * numero ("tecnologie 2").
 */

// Registro condiviso su window: acf/carousel e carousel-query sono bundle
// separati e ognuno avrebbe una sua copia del modulo.
const usedNames = (window.celadaCarouselNames = window.celadaCarouselNames || new Map());

/**
 * Rende univoco il nome del carosello nella pagina.
 *
 * @param {string} name
 * @returns {string}
 */
export function uniqueCarouselName(name) {
	const base  = (name || '').trim() || 'Carosello';
	const count = (usedNames.get(base) || 0) + 1;
	usedNames.set(base, count);

	return count === 1 ? base : `${base} ${count}`;
}

/**
 * Testo del titolo più vicino che precede il carosello nella sua sezione
 * (risale fino a 3 antenati), da usare come nome quando non ce n'è uno esplicito.
 *
 * @param {HTMLElement} el
 * @returns {string}
 */
export function nearestHeadingText(el) {
	let scope = el.parentElement;

	for (let depth = 0; scope && depth < 3; depth++, scope = scope.parentElement) {
		const headings = [...scope.querySelectorAll('h1, h2, h3, h4')].filter((h) => (
			!el.contains(h) && (h.compareDocumentPosition(el) & Node.DOCUMENT_POSITION_FOLLOWING)
		));

		if (headings.length) {
			return headings[headings.length - 1].textContent.replace(/\s+/g, ' ').trim();
		}
	}

	return '';
}

/**
 * Opzioni Splide `label` + `i18n` con il nome del carosello nei pulsanti.
 * `label` fa impostare a Splide role="region" e aria-label sulla root.
 *
 * @param {string} name - Nome già reso univoco.
 * @returns {{label: string, i18n: object}}
 */
export function carouselA11yOptions(name) {
	return {
		label: name,
		i18n: {
			prev:       `Slide precedente – ${name}`,
			next:       `Slide successiva – ${name}`,
			first:      `Vai alla prima slide – ${name}`,
			last:       `Vai all'ultima slide – ${name}`,
			slideX:     `Vai alla slide %s – ${name}`,
			pageX:      `Vai alla pagina %s – ${name}`,
			play:       `Avvia riproduzione automatica – ${name}`,
			pause:      `Metti in pausa – ${name}`,
			carousel:   'carosello',
			select:     'Seleziona la slide da mostrare',
			slide:      'slide',
			slideLabel: '%s di %s',
		},
	};
}
